export interface IColor {
    a?: number;
    r: number;
    g: number;
    b: number;
}

export const basicColors: { rgba: IColor; name: string }[] = [
    { rgba: { r: 240, g: 248, b: 255, a: 1 }, name: strings.colorPicker.aliceBlue },
    { rgba: { r: 250, g: 235, b: 215, a: 1 }, name: strings.colorPicker.antiqueWhite },
    { rgba: { r: 0, g: 255, b: 255, a: 1 }, name: strings.colorPicker.aqua },
    { rgba: { r: 127, g: 255, b: 212, a: 1 }, name: strings.colorPicker.aquamarine },
    { rgba: { r: 240, g: 255, b: 255, a: 1 }, name: strings.colorPicker.azure },
    { rgba: { r: 245, g: 245, b: 220, a: 1 }, name: strings.colorPicker.beige },
    { rgba: { r: 255, g: 228, b: 196, a: 1 }, name: strings.colorPicker.bisque },
    { rgba: { r: 0, g: 0, b: 0, a: 1 }, name: strings.colorPicker.black },
    { rgba: { r: 255, g: 235, b: 205, a: 1 }, name: strings.colorPicker.blanchedAlmond },
    { rgba: { r: 0, g: 0, b: 255, a: 1 }, name: strings.colorPicker.blue },
    { rgba: { r: 138, g: 43, b: 226, a: 1 }, name: strings.colorPicker.blueViolet },
    { rgba: { r: 165, g: 42, b: 42, a: 1 }, name: strings.colorPicker.brown },
    { rgba: { r: 222, g: 184, b: 135, a: 1 }, name: strings.colorPicker.burlyWood },
    { rgba: { r: 95, g: 158, b: 160, a: 1 }, name: strings.colorPicker.cadetBlue },
    { rgba: { r: 127, g: 255, b: 0, a: 1 }, name: strings.colorPicker.chartreuse },
    { rgba: { r: 210, g: 105, b: 30, a: 1 }, name: strings.colorPicker.chocolate },
    { rgba: { r: 255, g: 127, b: 80, a: 1 }, name: strings.colorPicker.coral },
    { rgba: { r: 100, g: 149, b: 237, a: 1 }, name: strings.colorPicker.cornflowerBlue },
    { rgba: { r: 255, g: 248, b: 220, a: 1 }, name: strings.colorPicker.cornsilk },
    { rgba: { r: 220, g: 20, b: 60, a: 1 }, name: strings.colorPicker.crimson },
    { rgba: { r: 0, g: 255, b: 255, a: 1 }, name: strings.colorPicker.cyan },
    { rgba: { r: 0, g: 0, b: 139, a: 1 }, name: strings.colorPicker.darkBlue },
    { rgba: { r: 0, g: 139, b: 139, a: 1 }, name: strings.colorPicker.darkCyan },
    { rgba: { r: 184, g: 134, b: 11, a: 1 }, name: strings.colorPicker.darkGoldenrod },
    { rgba: { r: 169, g: 169, b: 169, a: 1 }, name: strings.colorPicker.darkGray },
    { rgba: { r: 0, g: 100, b: 0, a: 1 }, name: strings.colorPicker.darkGreen },
    { rgba: { r: 189, g: 183, b: 107, a: 1 }, name: strings.colorPicker.darkKhaki },
    { rgba: { r: 139, g: 0, b: 139, a: 1 }, name: strings.colorPicker.darkMagenta },
    { rgba: { r: 85, g: 107, b: 47, a: 1 }, name: strings.colorPicker.darkOliveGreen },
    { rgba: { r: 255, g: 140, b: 0, a: 1 }, name: strings.colorPicker.darkOrange },
    { rgba: { r: 153, g: 50, b: 204, a: 1 }, name: strings.colorPicker.darkOrchid },
    { rgba: { r: 139, g: 0, b: 0, a: 1 }, name: strings.colorPicker.darkRed },
    { rgba: { r: 233, g: 150, b: 122, a: 1 }, name: strings.colorPicker.darkSalmon },
    { rgba: { r: 143, g: 188, b: 143, a: 1 }, name: strings.colorPicker.darkSeaGreen },
    { rgba: { r: 72, g: 61, b: 139, a: 1 }, name: strings.colorPicker.darkSlateBlue },
    { rgba: { r: 47, g: 79, b: 79, a: 1 }, name: strings.colorPicker.darkSlateGray },
    { rgba: { r: 0, g: 206, b: 209, a: 1 }, name: strings.colorPicker.darkTurquoise },
    { rgba: { r: 148, g: 0, b: 211, a: 1 }, name: strings.colorPicker.darkViolet },
    { rgba: { r: 255, g: 20, b: 147, a: 1 }, name: strings.colorPicker.deepPink },
    { rgba: { r: 0, g: 191, b: 255, a: 1 }, name: strings.colorPicker.deepSkyBlue },
    { rgba: { r: 105, g: 105, b: 105, a: 1 }, name: strings.colorPicker.dimGray },
    { rgba: { r: 30, g: 144, b: 255, a: 1 }, name: strings.colorPicker.dodgerBlue },
    { rgba: { r: 178, g: 34, b: 34, a: 1 }, name: strings.colorPicker.fireBrick },
    { rgba: { r: 255, g: 250, b: 240, a: 1 }, name: strings.colorPicker.floralWhite },
    { rgba: { r: 34, g: 139, b: 34, a: 1 }, name: strings.colorPicker.forestGreen },
    { rgba: { r: 255, g: 0, b: 255, a: 1 }, name: strings.colorPicker.fuchsia },
    { rgba: { r: 220, g: 220, b: 220, a: 1 }, name: strings.colorPicker.gainsboro },
    { rgba: { r: 248, g: 248, b: 255, a: 1 }, name: strings.colorPicker.ghostWhite },
    { rgba: { r: 255, g: 215, b: 0, a: 1 }, name: strings.colorPicker.gold },
    { rgba: { r: 218, g: 165, b: 32, a: 1 }, name: strings.colorPicker.goldenrod },
    { rgba: { r: 128, g: 128, b: 128, a: 1 }, name: strings.colorPicker.gray },
    { rgba: { r: 0, g: 128, b: 0, a: 1 }, name: strings.colorPicker.green },
    { rgba: { r: 173, g: 255, b: 47, a: 1 }, name: strings.colorPicker.greenYellow },
    { rgba: { r: 240, g: 255, b: 240, a: 1 }, name: strings.colorPicker.honeydew },
    { rgba: { r: 255, g: 105, b: 180, a: 1 }, name: strings.colorPicker.hotPink },
    { rgba: { r: 205, g: 92, b: 92, a: 1 }, name: strings.colorPicker.indianRed },
    { rgba: { r: 75, g: 0, b: 130, a: 1 }, name: strings.colorPicker.indigo },
    { rgba: { r: 255, g: 255, b: 240, a: 1 }, name: strings.colorPicker.ivory },
    { rgba: { r: 240, g: 230, b: 140, a: 1 }, name: strings.colorPicker.khaki },
    { rgba: { r: 230, g: 230, b: 250, a: 1 }, name: strings.colorPicker.lavender },
    { rgba: { r: 255, g: 240, b: 245, a: 1 }, name: strings.colorPicker.lavenderBlush },
    { rgba: { r: 124, g: 252, b: 0, a: 1 }, name: strings.colorPicker.lawnGreen },
    { rgba: { r: 255, g: 250, b: 205, a: 1 }, name: strings.colorPicker.lemonChiffon },
    { rgba: { r: 173, g: 216, b: 230, a: 1 }, name: strings.colorPicker.lightBlue },
    { rgba: { r: 240, g: 128, b: 128, a: 1 }, name: strings.colorPicker.lightCoral },
    { rgba: { r: 224, g: 255, b: 255, a: 1 }, name: strings.colorPicker.lightCyan },
    { rgba: { r: 250, g: 250, b: 210, a: 1 }, name: strings.colorPicker.lightGoldenrodYellow },
    { rgba: { r: 144, g: 238, b: 144, a: 1 }, name: strings.colorPicker.lightGreen },
    { rgba: { r: 211, g: 211, b: 211, a: 1 }, name: strings.colorPicker.lightGrey },
    { rgba: { r: 255, g: 182, b: 193, a: 1 }, name: strings.colorPicker.lightPink },
    { rgba: { r: 255, g: 160, b: 122, a: 1 }, name: strings.colorPicker.lightSalmon },
    { rgba: { r: 32, g: 178, b: 170, a: 1 }, name: strings.colorPicker.lightSeaGreen },
    { rgba: { r: 135, g: 206, b: 250, a: 1 }, name: strings.colorPicker.lightSkyBlue },
    { rgba: { r: 119, g: 136, b: 153, a: 1 }, name: strings.colorPicker.lightSlateGray },
    { rgba: { r: 176, g: 196, b: 222, a: 1 }, name: strings.colorPicker.lightSteelBlue },
    { rgba: { r: 255, g: 255, b: 224, a: 1 }, name: strings.colorPicker.lightYellow },
    { rgba: { r: 0, g: 255, b: 0, a: 1 }, name: strings.colorPicker.lime },
    { rgba: { r: 50, g: 205, b: 50, a: 1 }, name: strings.colorPicker.limeGreen },
    { rgba: { r: 250, g: 240, b: 230, a: 1 }, name: strings.colorPicker.linen },
    { rgba: { r: 255, g: 0, b: 255, a: 1 }, name: strings.colorPicker.magenta },
    { rgba: { r: 128, g: 0, b: 0, a: 1 }, name: strings.colorPicker.maroon },
    { rgba: { r: 102, g: 205, b: 170, a: 1 }, name: strings.colorPicker.mediumAquamarine },
    { rgba: { r: 0, g: 0, b: 205, a: 1 }, name: strings.colorPicker.mediumBlue },
    { rgba: { r: 186, g: 85, b: 211, a: 1 }, name: strings.colorPicker.mediumOrchid },
    { rgba: { r: 147, g: 112, b: 219, a: 1 }, name: strings.colorPicker.mediumPurple },
    { rgba: { r: 60, g: 179, b: 113, a: 1 }, name: strings.colorPicker.mediumSeaGreen },
    { rgba: { r: 123, g: 104, b: 238, a: 1 }, name: strings.colorPicker.mediumSlateBlue },
    { rgba: { r: 0, g: 250, b: 154, a: 1 }, name: strings.colorPicker.mediumSpringGreen },
    { rgba: { r: 72, g: 209, b: 204, a: 1 }, name: strings.colorPicker.mediumTurquoise },
    { rgba: { r: 199, g: 21, b: 133, a: 1 }, name: strings.colorPicker.mediumVioletRed },
    { rgba: { r: 25, g: 25, b: 112, a: 1 }, name: strings.colorPicker.midnightBlue },
    { rgba: { r: 245, g: 255, b: 250, a: 1 }, name: strings.colorPicker.mintCream },
    { rgba: { r: 255, g: 228, b: 225, a: 1 }, name: strings.colorPicker.mistyRose },
    { rgba: { r: 255, g: 228, b: 181, a: 1 }, name: strings.colorPicker.moccasin },
    { rgba: { r: 255, g: 222, b: 173, a: 1 }, name: strings.colorPicker.navajoWhite },
    { rgba: { r: 0, g: 0, b: 128, a: 1 }, name: strings.colorPicker.navy },
    { rgba: { r: 253, g: 245, b: 230, a: 1 }, name: strings.colorPicker.oldLace },
    { rgba: { r: 128, g: 128, b: 0, a: 1 }, name: strings.colorPicker.olive },
    { rgba: { r: 107, g: 142, b: 35, a: 1 }, name: strings.colorPicker.oliveDrab },
    { rgba: { r: 255, g: 165, b: 0, a: 1 }, name: strings.colorPicker.orange },
    { rgba: { r: 255, g: 69, b: 0, a: 1 }, name: strings.colorPicker.orangeRed },
    { rgba: { r: 218, g: 112, b: 214, a: 1 }, name: strings.colorPicker.orchid },
    { rgba: { r: 238, g: 232, b: 170, a: 1 }, name: strings.colorPicker.paleGoldenrod },
    { rgba: { r: 152, g: 251, b: 152, a: 1 }, name: strings.colorPicker.paleGreen },
    { rgba: { r: 175, g: 238, b: 238, a: 1 }, name: strings.colorPicker.paleTurquoise },
    { rgba: { r: 219, g: 112, b: 147, a: 1 }, name: strings.colorPicker.paleVioletRed },
    { rgba: { r: 255, g: 239, b: 213, a: 1 }, name: strings.colorPicker.papayaWhip },
    { rgba: { r: 255, g: 218, b: 185, a: 1 }, name: strings.colorPicker.peachPuff },
    { rgba: { r: 205, g: 133, b: 63, a: 1 }, name: strings.colorPicker.peru },
    { rgba: { r: 255, g: 192, b: 203, a: 1 }, name: strings.colorPicker.pink },
    { rgba: { r: 221, g: 160, b: 221, a: 1 }, name: strings.colorPicker.plum },
    { rgba: { r: 176, g: 224, b: 230, a: 1 }, name: strings.colorPicker.powderBlue },
    { rgba: { r: 128, g: 0, b: 128, a: 1 }, name: strings.colorPicker.purple },
    { rgba: { r: 255, g: 0, b: 0, a: 1 }, name: strings.colorPicker.red },
    { rgba: { r: 188, g: 143, b: 143, a: 1 }, name: strings.colorPicker.rosyBrown },
    { rgba: { r: 65, g: 105, b: 225, a: 1 }, name: strings.colorPicker.royalBlue },
    { rgba: { r: 139, g: 69, b: 19, a: 1 }, name: strings.colorPicker.saddleBrown },
    { rgba: { r: 250, g: 128, b: 114, a: 1 }, name: strings.colorPicker.salmon },
    { rgba: { r: 244, g: 164, b: 96, a: 1 }, name: strings.colorPicker.sandyBrown },
    { rgba: { r: 46, g: 139, b: 87, a: 1 }, name: strings.colorPicker.seaGreen },
    { rgba: { r: 255, g: 245, b: 238, a: 1 }, name: strings.colorPicker.seashell },
    { rgba: { r: 160, g: 82, b: 45, a: 1 }, name: strings.colorPicker.sienna },
    { rgba: { r: 192, g: 192, b: 192, a: 1 }, name: strings.colorPicker.silver },
    { rgba: { r: 135, g: 206, b: 235, a: 1 }, name: strings.colorPicker.skyBlue },
    { rgba: { r: 106, g: 90, b: 205, a: 1 }, name: strings.colorPicker.slateBlue },
    { rgba: { r: 112, g: 128, b: 144, a: 1 }, name: strings.colorPicker.slateGray },
    { rgba: { r: 255, g: 250, b: 250, a: 1 }, name: strings.colorPicker.snow },
    { rgba: { r: 0, g: 255, b: 127, a: 1 }, name: strings.colorPicker.springGreen },
    { rgba: { r: 70, g: 130, b: 180, a: 1 }, name: strings.colorPicker.steelBlue },
    { rgba: { r: 210, g: 180, b: 140, a: 1 }, name: strings.colorPicker.tan },
    { rgba: { r: 0, g: 128, b: 128, a: 1 }, name: strings.colorPicker.teal },
    { rgba: { r: 216, g: 191, b: 216, a: 1 }, name: strings.colorPicker.thistle },
    { rgba: { r: 255, g: 99, b: 71, a: 1 }, name: strings.colorPicker.tomato },
    { rgba: { r: 64, g: 224, b: 208, a: 1 }, name: strings.colorPicker.turquoise },
    { rgba: { r: 238, g: 130, b: 238, a: 1 }, name: strings.colorPicker.violet },
    { rgba: { r: 245, g: 222, b: 179, a: 1 }, name: strings.colorPicker.wheat },
    { rgba: { r: 255, g: 255, b: 255, a: 1 }, name: strings.colorPicker.white },
    { rgba: { r: 245, g: 245, b: 245, a: 1 }, name: strings.colorPicker.whiteSmoke },
    { rgba: { r: 255, g: 255, b: 0, a: 1 }, name: strings.colorPicker.yellow },
    { rgba: { r: 154, g: 205, b: 50, a: 1 }, name: strings.colorPicker.yellowGreen }
];
